// extracted by mini-css-extract-plugin
module.exports = {"appContainer":"App_appContainer__B6B7E"};